


















import { Component, Mixins, Ref } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types/index";
import { SortWarekiDate } from "#/utility/appSort";
import AxiosMixin from "@/mixins/axiosMixin";
import BaseReportList from "@/components/patient/BaseReportList.vue";
import { ServiceReport } from "#/model/servicereport";
import { COMMON } from "#/const";

@Component({
  components: {
    BaseReportList
  }
})
export default class ServiceList extends Mixins(AxiosMixin) {
  /** 差し戻し */
  private REPORT_REMAND = COMMON.REPORT_STATUS.REMAND;

  @Ref("reportList") private readonly reportList?: BaseReportList;

  private patientId = 0;

  private items: ServiceReport[] = []; //サービス内容確認書

  private headers: DataTableHeader[] = [
    {
      text: "説明確認日",
      value: "check_date_wareki",
      align: "start",
      width: "152px",
      sort: SortWarekiDate
    }
  ];
  private commentHeader = {
    text: "コメント",
    value: "remand.comment"
  };

  public created(): void {
    this.patientId = Number(this.$route.params.id);
    // 未提出タブ以外ではタブ変更後の取得処理に任せる
    if (!this.$route.query.reporttab || this.$route.query.reporttab === "0") {
      this.fetchServiceReport({ tab: 0, page: 0 });
    }
  }

  private clickNew(): void {
    this.$router.push({
      name: "PatientServiceEdit",
      params: { id: String(this.patientId), servicereportid: "0" }
    });
  }

  private clickEdit(item: ServiceReport): void {
    this.$router.push({
      name: "PatientServiceEdit",
      params: { id: String(this.patientId), servicereportid: String(item.id) }
    });
  }

  //サービス内容確認情報一覧取得
  private fetchServiceReport(obj: { tab: number; page: number }): void {
    this.postJsonCheck(
      window.base_url + "/api/patient/servicereports/get",
      {
        patient_id: this.patientId,
        tab: obj.tab,
        page: obj.page
      },
      res => {
        if (res.data.items != null) {
          this.reportList?.finishLoaded(res.data.items);
          if (obj.page != 0) {
            this.items = this.items.concat(res.data.items);
          } else {
            this.items = res.data.items;
          }
        }
      }
    );
  }

  //差し戻し
  private setRemand(recordItem: {
    item: ServiceReport;
    comment: string;
  }): void {
    recordItem.item.status = this.REPORT_REMAND;
    recordItem.item.remand.comment = recordItem.comment;
    this.postJsonCheck(
      window.base_url + "/api/patient/servicereport/saveRemand",
      {
        service_report: recordItem.item
      },
      () => {
        this.items = this.items.filter(v => v.id !== recordItem.item.id);
      }
    );
  }

  //PDF
  private pdf(item: ServiceReport): void {
    this.makePdf(window.base_url + "/api/patient/servicereport/preview/ids", {
      patient_id: this.patientId,
      service_report_ids: [item.id],
      service_reports: [item]
    });
  }
}
